import types from "../../actions/clientsActions/types";
import { FETCH_STATUS } from "../../../constants/index";

export const newClient = (
    state = {
        data: {},
        status: FETCH_STATUS.NOT_LOADED,
        error: "",
    },
    action
) => {
    const { payload: { error, data } = {} } = action;
    switch (action.type) {
        case types.SAVE_NEW_CLIENT_REQUEST:
            return {
                ...state,
                status: FETCH_STATUS.LOADING,
                error: null,
            };
        case types.SAVE_NEW_CLIENT_SUCCESS:
            return {
                data: data,
                status: FETCH_STATUS.LOADED,
            };
        case types.SAVE_NEW_CLIENT_FAILURE:
            return {
                ...state,
                status: FETCH_STATUS.FAILED,
                error,
            };

        default:
            return state;
    }
};

export default newClient;